import React, { useEffect, useState } from "react";

const PrintableTableAgGrid = ({ gridApi, formatters = {}, className = "", thClassName = "", tdClassName = "" }) => {
  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!gridApi) return;

    const updatePrintableData = () => {

      const columns = gridApi.getAllDisplayedColumns();
      if (!columns || columns.length === 0) return;

      const extractedHeaders = columns
        .filter(col => {
          const field = col.getColDef().field;

          return field !== undefined && field !== null;
        })
        .map(col => {
          const def = col.getColDef();
          return {
            header: def.printableTableAlias ? def.printableTableAlias : def.headerName,
            field: def.field,
            flex: def.flex ?? 1
          };
        });

      if (extractedHeaders.length === 0) return;

      const totalFlex = extractedHeaders.reduce((acc, col) => acc + col.flex, 0);
      const headersWithWidth = extractedHeaders.map(col => ({
        ...col,
        width: `${(col.flex / totalFlex) * 100}%`
      }));

      const extractedRows = [];
      gridApi.forEachNodeAfterFilterAndSort((node) => {
        extractedRows.push(node.data);
      });

      setHeaders(headersWithWidth);
      setRows(extractedRows);
    };

    gridApi.addEventListener("firstDataRendered", updatePrintableData);
    gridApi.addEventListener("modelUpdated", updatePrintableData);
    gridApi.addEventListener("displayedColumnsChanged", updatePrintableData);
    gridApi.addEventListener("gridReady", updatePrintableData);

    updatePrintableData();

    return () => {
      gridApi.removeEventListener("firstDataRendered", updatePrintableData);
      gridApi.removeEventListener("modelUpdated", updatePrintableData);
      gridApi.removeEventListener("displayedColumnsChanged", updatePrintableData);
      gridApi.removeEventListener("gridReady", updatePrintableData);
    };
  }, [gridApi]);

  const renderCell = (field, row) => {
    if (!row) return "";
    if (formatters[field]) {
      return formatters[field](row);
    }
    return row[field] ?? "";
  };

  if (!gridApi || headers.length === 0) return null;

  return (
    <table className={["hidden print:table border border-[#e0e1e3] border-collapse table-fixed w-full text-[14px]", className].join(" ")}>
      <thead className="w-full print:table-row-group!">
      <tr>
        {headers.map(h => (
          <th
            key={h.field}
            style={{ width: h.width }}
            className={[
              "p-2 bg-[#efefef] border border-[#e0e1e3] border-collapse text-start",
              thClassName,
            ].join(" ")}
          >
            {h.header}
          </th>
        ))}
      </tr>
      </thead>

      <tbody>
      {rows.map((row, i) => (
        <tr key={i}>
          {headers.map(h => (
            <td
              className={[
                i % 2 === 0 ? 'bg-white' : 'bg-[#efefef]',
                ' p-1 border border-[#e0e1e3] border-collapse',
                tdClassName
              ].join(" ")}
              key={h.field}
            >
              {renderCell(h.field, row)}
            </td>
          ))}
        </tr>
      ))}
      </tbody>
    </table>
  );
};

export default PrintableTableAgGrid;